import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Radios from '../../component/Radios';
import Profiles from '../../component/Profiles';
import MypageleftArea from '../../component/MypageleftArea';


import { getMemberinfo } from "../../utils/utils";


import * as APIS from "../../utils/service";
import Select from '../../component/Select';

const ABORT_TEXT = "회원탈퇴 약관을 확인했으며 이에 동의합니다"

export default function Abortpage({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [termabort, settermabort] = useState(''); 
    const [memberinfos, setmemberinfos] = useState(''); 
    const [abortCker, setabortCker] = useState(''); 
    const [abortCker2, setabortCker2] = useState(''); 
    const [submitflag, setsubmitflag] = useState(false); 
    const [popflag, setpopflag] = useState(false); 
    const [abortSelect, setabortSelect] = useState(''); 
    const [popcomments, setpopcomments] = useState(''); 
    const [errmsg, seterrmsg] = useState('');   


    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);

    useEffect(() => {
        
        let sender = {
            type: 4
        }
        APIS.postData('/term', sender).then(({ data }) => {
            //console.log(data);
            settermabort(data);
        }).catch((e) => {
        }).finally(() => {
        }); 
    }, []);
    useEffect(() => {
        if(memberinfos?.leave_option*1 === 2 || memberinfos?.leave_option*1 === 3){
            if(abortCker === ABORT_TEXT && abortCker2 === 0){
                setsubmitflag(true);
            } else {
                setsubmitflag(false);
            }
        } else {
            if(abortCker === ABORT_TEXT){
                setsubmitflag(true);
            } else {
                setsubmitflag(false);
            }
        }
    }, [abortCker, abortCker2]);

    const memberAbortSubmit = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {
            delete_reason: abortSelect === '기타' ? popcomments : abortSelect
        }
        APIS.postData('/v1/auth/leave', sender).then(({ data }) => {
            //console.log(data);
            dispatch(
                useropen({
                    userdata: ''
                })
            );   
            navigate("/");

        }).catch(({ response }) => {
            const { data } = response;
            console.log(response);
            seterrmsg(data?.msg);
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });          
    }

    return(
        <>
        <Layout header={false} actives={''}>
            <div className='mypagearea'>
                <div >
                    <MypageleftArea pages={0} />
                </div>
                <div 
                    className='padding32'
                >
                    <div className='backbuttonarea'>
                        <div>
                            <button onClick={() => { navigate(-1); }}>
                                <img src={`./images/icons/back.svg`} /> 
                            </button>
                            <span className='fontsize16 bolds'>탈퇴하기</span>
                        </div>
                        <button onClick={() => { navigate('/Mypage'); }}>
                            내정보
                        </button>
                    </div>
                    <div className='pagetitle fontsize20 bolds'>회원탈퇴</div>

                    <div className='mypageinputsarea'>
                        {/* <div 
                            className='margint20 color666' style={{ textAlign: 'left' }}
                            dangerouslySetInnerHTML={{__html: termabort}}
                        /> */}
                        <div
                            style={{
                                textAlign: 'left', marginTop: 30
                            }}
                        >
                        회원님께서는 언제든지 회원탈퇴를 할 수 있으며, 회사는 특별한 사정이 없는 한 이를 지체 없이 처리합니다.<br /><br />
                        회원 탈퇴시 회원님의 정보는 내부 규정 및 관련 법령에서 정하는 바에 따라 관리하며, 서비스 운영정책에서 정하는  바에 따라 서비스에 다시 가입하는 것이 제한될 수 있습니다.<br /><br />
                        <b>회원탈퇴 시 등록하신 매물 및 고객정보는 삭제되며 어떠한 방법으로도 복구 및 제공해 드릴 수 없습니다. 관련 정보가 필요하신 분은 <span style={{ textDecoration: 'underline'}}>반드시 탈퇴 전 고객센터를 통해 요청</span>하셔야 하며, 그러지 않을 경우 회사는 어떠한 책임도 지지 않습니다.</b>
                        </div>

                        <div style={{
                            display:"flex",
                            flexDirection:"column",
                            alignItems:"start",
                            gap:5,
                        }}>
                            {/* <Radios
                                linetype={'checkimg'}
                                values={abortCker}
                                setvalues={(e) => {
                                    if(abortCker === 0){
                                        setabortCker('');
                                    } else {
                                        setabortCker(e);
                                    }
                                }}                                
                                namevalue={[
                                    {names: '회원탈퇴 약관을 충분히 확인했으며, 이에 동의함', values: 0},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            /> */}

                            <p>회원 탈퇴약관에 동의하시면 아래 문구를 동일하게 입력하세요.</p>
                            <p><b>{ABORT_TEXT}</b></p>
                            <Input
                                className={`inputs`}
                                placeholder={"문구 입력"}
                                setValue={setabortCker}
                                value={abortCker}
                                name="abortText"
                            />
                        </div>
                        {/* 불필요한 문구 삭제 */}
                        {/* {memberinfos?.leave_option === 1 &&
                            <div className='bolds'>
                                회원탈퇴시 회원님의 [매물정보][고객정보]는 본인과 대표 모두의 계정에서 삭제됩니다.
                            </div>
                        } */}
                        {(memberinfos?.leave_option === 2 || memberinfos?.leave_option === 3) &&
                        <div>
                            <Radios
                                linetype={'checkimg'}
                                values={abortCker2}
                                setvalues={(e) => {
                                    if(abortCker2 === 0){
                                        setabortCker2('');
                                    } else {
                                        setabortCker2(e);
                                    }
                                }}
                                namevalue={[
                                    {names: '회원탈퇴시 회원님의 [매물정보][고객정보]는 대표공인중개사에게 귀속됩니다.', values: 0},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            />
                        </div>
                        }

                        
                        <div
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8
                            }}
                        >
                            <Button
                                disabled={!submitflag}
                                buttonTxt={'서비스 탈퇴하기'}
                                onPress={() => { 
                                    if(submitflag ===  true){
                                        setpopflag(true);
                                    }
                                }}
                                styles={{
                                    width: 200
                                }}
                            />     
                            <Button
                                buttonTxt={'서비스 계속 이용하기'}
                                onPress={() => { 
                                    navigate(-1);
                                }}
                                styles={{
                                    width: 200
                                }}                                
                            />                                
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
        {popflag === true &&
        <div className='PopupArea'>
            <div>
                <div className='PopupAreaBG' 
                    //onClick={() => { setpopflag(false); }}
                />
                <div className='PopupAreaContents'>
                    <div>
                        <div className="popTitle padding20">
                            <span >탈퇴하기</span>
                            <button
                                onClick={() => {
                                    setpopflag(false);
                                }}
                            >
                                <img src="./images/icons/x.svg" width='20' />                                            
                            </button>
                        </div>
                        <div className="padding32">
                            <div className='popcontents'>
                                <div style={{ width: '100%' }}>
                                    <div>
                                        <Select 
                                            setValues={setabortSelect}
                                            values={abortSelect}
                                            selectData={[
                                                {labels: '선택하세요', values: ''},
                                                {labels: '탈퇴 후 재가입', values: '탈퇴 후 재가입'},
                                                {labels: '이용 빈도 낮음', values: '이용 빈도 낮음'},
                                                {labels: '사이트 이용이 불편', values: '사이트 이용이 불편'},
                                                {labels: '기록 삭제 목적', values: '기록 삭제 목적'},
                                                {labels: '비매너 사용자 다수', values: '비매너 사용자 다수'},
                                                {labels: '직접입력', values: '직접입력'},
                                            ]}
                                        />  
                                    </div>
                                    {abortSelect === '직접입력' &&
                                    <div style={{ width: '100%', marginTop: 10 }}>
                                        <textarea
                                            onChange={(e) => {
                                                setpopcomments(e.target.value);
                                            }}
                                            placeholder='사유를 입력해 주세요.'
                                            style={{
                                                width: '100%', height: 100, padding: 12,
                                                borderRadius: 4, border: '1px solid #DDD'
                                            }}
                                        >{popcomments}</textarea>
                                    </div>
                                    }
                                </div>
                            </div>
                            {errmsg &&
                            <div className='input_error ' style={{ width: '100%', alignItems: 'center', justifyContent: 'center'}}>
                                {errmsg}
                            </div>}
                            
                            <div className='popbuttons'>
                                <div>
                                    <Button
                                        disabled={true}
                                        buttonTxt={'아니오'}
                                        onPress={() => { setpopflag(false); }}
                                    />                                    
                                </div>
                                <div>
                                    <Button
                                        buttonTxt={'탈퇴하기'}
                                        onPress={() => { memberAbortSubmit(); }}
                                    />                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        }

        </>
    )
}

